import { AgGridVue } from '@ag-grid-community/vue3';
AgGridVue.compatConfig = { MODE: 3 };
// eslint-disable-next-line import/prefer-default-export
export { AgGridVue };
